"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupDisclaimer = void 0;
const react_1 = __importDefault(require("react"));
const use_modal_disclaimer_1 = require("../modal-disclaimer/use-modal-disclaimer");
const components_core_1 = require("@volkswagen-onehub/components-core");
const StyledSubTextWrapper = components_core_1.styled.span `
  pointer-events: auto;
  border: none;
  vertical-align: super;
  border-radius: 8px;
  padding: 2px 5px;
  outline: 0px;
  line-height: 0;
  font-weight: bold;
  color: rgb(0, 0, 0);
  background: rgb(223, 228, 232);
  font-size: 9px !important;
  &:active,
  &:focus {
    color: rgb(255, 255, 255);
    background: rgb(0, 64, 197);
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px,
      rgb(106, 118, 125) 0px 0px 0px 3px;
  }
  &:hover {
    color: rgb(255, 255, 255);
    background: rgb(0, 64, 197);
  }
`;
const StyledSubTextContainer = components_core_1.styled.span `
  border: 0px;
  padding: 0px;
  margin: 0px;
  background: none;
  cursor: pointer;
  position: relative;
  text-align: center;
  &:focus + span-text {
    color: rgb(255, 255, 255);
    background: rgb(0, 64, 197);
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px,
      rgb(106, 118, 125) 0px 0px 0px 3px;
  }
`;
const SupDisclaimer = props => {
    const { children } = props;
    const updateDisclaimer = (0, use_modal_disclaimer_1.useActiveModalDisclaimer)();
    return (react_1.default.createElement("div", { onClick: () => {
            updateDisclaimer &&
                updateDisclaimer(children);
        }, style: { display: 'contents' } },
        react_1.default.createElement(StyledSubTextContainer, { className: "sub-text-constainer" },
            react_1.default.createElement(StyledSubTextWrapper, { className: "span-text", tabIndex: "1" }, children))));
};
exports.SupDisclaimer = SupDisclaimer;
